import { useState, useEffect } from "react";
import { loadConnectAndInitialize } from "@stripe/connect-js";
import { createStripeAccountSession } from "../api";

export const useStripeConnect = (connectedAccountId) => {
  const [stripeConnectInstance, setStripeConnectInstance] = useState();

  useEffect(() => {
    if (connectedAccountId) {
      setStripeConnectInstance(
        loadConnectAndInitialize({
          publishableKey:
            (process.env.REACT_APP_ENV || "prod") !== "prod"
              ? "pk_test_51JlXkKLHypYrxT5S2XmQNeovPqyEyxmRwpK6uv5FzO3IbwmoIc81WWSQfWC0CBljKklMHL2SHqwvFILLF2JaVOOs00YNusWGUK"
              : "pk_live_51JlXkKLHypYrxT5S38CGbEeMcTNzljxVND4at3VLwsLbMw7tkjS6uG77hpsNaINW1lCynIxNQCkgal6vVzq9Xb0C00IZcpD0Ym",
          fetchClientSecret: async () => {
            const response = await createStripeAccountSession({
              accountId: connectedAccountId,
            });
            return response.clientSecret;
          },
          appearance: {
            overlays: "drawer",
            variables: {
              colorPrimary: "#fff",
              colorBackground: "#160B23",
              colorText: "#fff",
              colorSecondaryText: "#d8c8f4",
              borderRadius: "8px",
              fontFamily: "'Roboto', sans-serif",
              fontSizeBase: "16px",
              buttonPrimaryColorBackground: "#160B23",
              buttonPrimaryColorBorder: "#d8c8f4",
              buttonPrimaryColorText: "#d8c8f4",
            },
          },
        })
      );
    }
  }, [connectedAccountId]);

  return stripeConnectInstance;
};

export default useStripeConnect;
